module.exports = __webpack_public_path__ + "img/lipstick_gift.c742893b.svg";